import axios from 'axios';
import config from '../utils/config';

// Create an Axios instance with default config for admin API
const adminApiClient = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding admin auth token
adminApiClient.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    const jwtSecret = localStorage.getItem('jwtSecret');
    
    if (adminToken) {
      // Use standard 'Bearer' prefix for JWT tokens
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    
    if (jwtSecret) {
      config.headers['X-JWT-Secret'] = jwtSecret;
    }
    
    // Debug request
    console.log(`[Admin API Request] ${config.method.toUpperCase()} ${config.url}`, config);
    
    return config;
  },
  (error) => {
    console.error('[Admin API Request Error]', error);
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
adminApiClient.interceptors.response.use(
  (response) => {
    // Debug successful response
    console.log(`[Admin API Response] ${response.config.method.toUpperCase()} ${response.config.url}`, response.data);
    
    return response.data;
  },
  (error) => {
    // Debug error response
    console.error(`[Admin API Error] ${error.config?.method?.toUpperCase()} ${error.config?.url}`, {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    });
    
    // Handle authentication errors
    if (error.response && error.response.status === 401) {
      // Clear authentication and redirect to admin login
      localStorage.removeItem('adminToken');
      localStorage.removeItem('admin');
      
      if (window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default adminApiClient; 